import { Vector3, type PerspectiveCamera } from 'three';

export const siteBridge = {
  camera: null as PerspectiveCamera | null,
  anchor: new Vector3(),
  active: false,
  rangeM: 50,
  globeTarget: false,
  render: null as (() => void) | null,
  snapshot: null as (() => HTMLCanvasElement) | null,
  openAsset: null as ((assetId: string) => void) | null,
};
